export const areParamsEqual = (
  param1?: null | string,
  param2?: null | string
) =>
  param1 !== null &&
  param1 !== undefined &&
  param2 !== null &&
  param2 !== undefined &&
  decodeURI(param1.toLowerCase()) === decodeURI(param2.toLowerCase());

export const MISSION_ID_PARAM = 'missionId';
